import { hasParentNode } from '@atlaskit/editor-prosemirror/utils';
export var isNestedInExpand = function isNestedInExpand(state) {
  return hasParentNode(function (node) {
    return node.type === state.schema.nodes.expand || node.type === state.schema.nodes.nestedExpand;
  })(state.selection);
};